import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent backdrop-blur-sm'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/9d69b025-498f-41a7-adf2-7170783fc8ba.png"
            alt="BRIMA Logo"
            className="h-10 w-auto"
          />
          <span className={`text-2xl font-bold tracking-tight ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
            BRIMA
          </span>
        </div>

        <div className="flex items-center gap-12">
          <button
            onClick={() => scrollToSection('vpn-service')}
            className={`text-sm font-light tracking-[8px] uppercase transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-light tracking-[8px] uppercase transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Security
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-light tracking-[8px] uppercase transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white'
            }`}
          >
            Contact
          </button>
        </div>

        <button
          onClick={() => scrollToSection('pricing')}
          className="px-8 py-3 bg-[#00D9FF] text-white rounded-full text-sm font-medium hover:bg-[#00C4E6] transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Get Started
        </button>
      </div>
    </nav>
  );
}
